import { ArretAAT } from './types';
import ArretAATState from './types';
import { MutationTree, Module, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';

const namespaced: boolean = true;

export const state: ArretAATState = {
	arret: new ArretAAT()
};

export const mutations: MutationTree<ArretAATState> = {
	mutateArret(state: ArretAATState, arret: ArretAAT): void {
		state.arret = Object.assign({}, arret);
	},
	mutateArretATMP(state: ArretAATState, arret: ArretAAT): void {
		if (state.arret && arret) {
			state.arret.isEnRapportAvecATMP = arret.isEnRapportAvecATMP;
			state.arret.dateDebutATMP = arret.dateDebutATMP;
		}
	},
	mutateArretDuree(state: ArretAATState, arret: ArretAAT): void {
		if (state.arret && arret) {
			state.arret.dateDebut = arret.dateDebut;
			state.arret.dateFin = arret.dateFin;
			state.arret.isRepriseTempsLeger = arret.isRepriseTempsLeger;
			state.arret.dateDebutRepriseTL = arret.dateDebutRepriseTL;
			state.arret.dateFinRepriseTL = arret.dateFinRepriseTL;
			state.arret.dureeTL = arret.dureeTL;
			state.arret.duree = arret.duree;
			state.arret.raisonChangeDateDebut = arret.raisonChangeDateDebut;
		}
	}
};

export const actions: ActionTree<ArretAATState, RootState> = {
	updateArret(state, arret: ArretAAT): void {
		state.commit('mutateArret', arret);
	},
	updateArretATMP(state, arret: ArretAAT): void {
		state.commit('mutateArretATMP', arret);
	},
	updateArretDuree(state, arret: ArretAAT): void {
		state.commit('mutateArretDuree', arret);
	}
};

export const getters: GetterTree<ArretAATState, RootState> = {
	getArret(state) {
		return state.arret;
	}
};

export const arretAAT: Module<ArretAATState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
